import React from 'react';
import { ProgramRequestsTable } from './admin/program-requests-table';

export const DeletedTab = ({ data }) => (
    <div
        className="tab-pane fade show active"
        id="deleted"
        role="tabpanel"
        aria-labelledby="deleted-tab"
    >
        <div className="card">
            <div className="table-responsive">
                {data && data[0] && data[0].isAdmin && (
                    <ProgramRequestsTable tableData={data} />
                )}
            </div>
        </div>
    </div>
);
